export const css = {
	root: '_jKdHah4',
	loading: '_1cNpsz4Y',
	titleBlock: '_3diDtKxu',
	title: '_7NJ172GA',
	questionBlock: '_1tRKqGWg',
	count: '_25ux-wEX',
	question: '_1xYxGLT9',
	select: '_1_osmTCa',
	microViewWrapper: 'D5OG3I1k',
	microView: '_2svjVsGO',
	' _key': 'quiz-widgets/quizfolder'
};

export default css;
